import {Box, Heading, Text, SimpleGrid, Button} from "@chakra-ui/react";
import {dialog, regions} from "../constants";

const RegionSelector = () => {
    return (
        <Box boxShadow="md" p={6} borderRadius="xl" textAlign="center" mb={10}>
            <Heading as={"h2"} size={{ base: "xl", md: "2xl", lg: "3xl" }} mb={2}>
                Select your country to get a free solar quote
            </Heading>
            <Text fontSize={"lg !important"} color={"black !important"} mb={6}>
                (Takes just a minute to complete)
            </Text>

            <SimpleGrid columns={{ base: 1, sm: 2, md: 3, lg: 4 }} gap={{ base: 2, md: 4 }} px={{ base: 2, md: 4 }}>
                {regions.map((region) => (
                    <Button
                        key={region}
                        _hover={{ bg: "green.500" }}
                        transition="all 0.2s ease"
                        bg={"gray.700"}
                        fontWeight="bold"
                        borderRadius="lg"
                        p={{ base: 6, md: 10 }}
                        fontSize={{ base: "sm", sm: "md", md: "lg" }}
                        onClick={() => dialog.open("a", {
                            title: "Get FREE Solar Quotes"
                        })}
                    >
                        {region}
                    </Button>
                ))}
            </SimpleGrid>
        </Box>
    );
};

export default RegionSelector;
